/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Физическое лицо
 * @export
 * @interface IndividualEntity
 */
export interface IndividualEntity {
  /**
   *
   * @type {string}
   * @memberof IndividualEntity
   */
  organizationType: IndividualEntityOrganizationTypeEnum
  /**
   * ИНН заказчика
   * @type {string}
   * @memberof IndividualEntity
   */
  inn: string
  /**
   * СНИЛС
   * @type {string}
   * @memberof IndividualEntity
   */
  snils: string
  /**
   * Серия номер паспорта
   * @type {string}
   * @memberof IndividualEntity
   */
  passportSeriesNumber: string
  /**
   * Наименование заказчика с указанием краткого формата ОПФ
   * @type {string}
   * @memberof IndividualEntity
   */
  name: string
  /**
   * Адрес заказчика, с указанием индекса, города, улица и квартиры.
   * @type {string}
   * @memberof IndividualEntity
   */
  address: string
  /**
   * Адрес для корреспонденции заказчика. Заказчик может указать адрес в произвольном формате
   * @type {string}
   * @memberof IndividualEntity
   */
  addressCorrespondent?: string
  /**
   * совпадает ли addresss и addressCorrespondent
   * @type {boolean}
   * @memberof IndividualEntity
   */
  addressEqual: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum IndividualEntityOrganizationTypeEnum {
  IndividualEntity = 'INDIVIDUAL_ENTITY',
}

/**
 * Check if a given object implements the IndividualEntity interface.
 */
export function instanceOfIndividualEntity(
  value: object
): value is IndividualEntity {
  if (!('organizationType' in value) || value['organizationType'] === undefined)
    return false
  if (!('inn' in value) || value['inn'] === undefined) return false
  if (!('snils' in value) || value['snils'] === undefined) return false
  if (
    !('passportSeriesNumber' in value) ||
    value['passportSeriesNumber'] === undefined
  )
    return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('address' in value) || value['address'] === undefined) return false
  if (!('addressEqual' in value) || value['addressEqual'] === undefined)
    return false
  return true
}

export function IndividualEntityFromJSON(json: any): IndividualEntity {
  return IndividualEntityFromJSONTyped(json, false)
}

export function IndividualEntityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IndividualEntity {
  if (json == null) {
    return json
  }
  return {
    organizationType: json['organizationType'],
    inn: json['inn'],
    snils: json['snils'],
    passportSeriesNumber: json['passportSeriesNumber'],
    name: json['name'],
    address: json['address'],
    addressCorrespondent:
      json['addressCorrespondent'] == null
        ? undefined
        : json['addressCorrespondent'],
    addressEqual: json['addressEqual'],
  }
}

export function IndividualEntityToJSON(value?: IndividualEntity | null): any {
  if (value == null) {
    return value
  }
  return {
    organizationType: value['organizationType'],
    inn: value['inn'],
    snils: value['snils'],
    passportSeriesNumber: value['passportSeriesNumber'],
    name: value['name'],
    address: value['address'],
    addressCorrespondent: value['addressCorrespondent'],
    addressEqual: value['addressEqual'],
  }
}
